/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {detect} from 'detect-browser'
import {AirtimeExceptions} from "../api/Airtime";

export const browser = detect()

/**
 * Created by Michal Rohac (H172336) on 3/26/2018.
 */
export const objectToArray = (obj) => {
    return !obj ? [] : Object.keys(obj).map(key => obj[key])
}

/**
 * Sets language setting into local storage and reloads whole window
 */
export const changeLanguage = (lang) => {
    localStorage.setItem('lang', lang);
    window.location.reload();
}

/**
 * Gets current language setting from browser local storage
 */
export const getCurrentLanguage = () => {
    return localStorage.getItem('lang');
}

export const getFaultName = (fault) => {
    return fault.name + ': ' + fault.primarySymptom.name
}

export const getBreadcrumbItemsFleet = (fleets, leafFleetClickable) => {
    //Filter removes Fleets fleet (id=0) from path
    return fleets
        .filter(f => f.id !== 0)
        .map((f, index) => {
            return {name: f.name, url: leafFleetClickable || index < fleets.length - 1 ? '/fleets/' + f.id : null}
        });
}

export const getBreadcrumbItemsAsset = (fleets, asset, assetClickable, hdaBreadcrumb, external) => {
    let items = [];
    if (hdaBreadcrumb) {
        items.push({name: hdaBreadcrumb, url: external ? '/airtime/engineHistory' : '/assets'})
    } else {
        items = getBreadcrumbItemsFleet(fleets, true)
    }
    let apiUrl = null;
    if (assetClickable) {
        if (external) {
            apiUrl = '/airtime/asset/' + asset.id
        } else {
            apiUrl = '/assets/' + asset.id
        }
    }
    items.push({name: asset.name, url: apiUrl})
    return items
}

export const getBreadcrumbItemsFault = (fault, hdaBreadcrumb, leafItem, external) => {
    const items = getBreadcrumbItemsAsset(fault.path, fault.asset, true, hdaBreadcrumb, external)
    let assetPath = '/assets/';
    if (external) {
        assetPath = '/airtime/asset/'
    }
    items.push({name: fault.name, url: leafItem ? assetPath + fault.asset.id + '/faults/' + fault.id : null})
    if (leafItem) {
        items.push({name: leafItem, url: null})
    }
    return items
}

export const getBreadcrumbItemsUrl = (url, user) => {
    const urlItems = url.split("/")
    const items = []
    urlItems.filter(item => item.length > 0).forEach((currentValue, index) => {
        items.push({url: "/" + currentValue, name: currentValue})
        if (items.length > 1) {
            items[index].url = items[index - 1].url + items[index].url
        }
    })

    //set user name instead id
    items[items.length - 1].name = user.userName

    return items
}

export const getBreadcrumbItemsAdminUser = (intl, user) => {
    const items = []
    items.push({name: intl.formatMessage({id: "page.admin"}), url: '/administration/users'})
    items.push({name: intl.formatMessage({id: "admin.tab.users"}), url: '/administration/users'})
    items.push({
        name: (user.userName && user.userName.length > 0) ? user.userName : intl.formatMessage({id: "admin.tab.users.new"}),
        url: '/administration/users/' + ((user.id > 0) ? user.id : 'new'),
    })
    return items;
}

export const getBreadcrumbItemsAdminFleet = (intl, fleet) => {
    const items = []
    items.push({name: intl.formatMessage({id: "page.admin"}), url: '/administration/users'})
    items.push({name: intl.formatMessage({id: "admin.tab.fleets.and.assets"}), url: '/administration/fleets'})
    items.push({
        name: (fleet.name && fleet.name.length > 0) ? fleet.name : intl.formatMessage({id: "admin.tab.fleets.new"}),
        url: '/administration/fleets/' + ((fleet.id > 0) ? fleet.id : 'new'),
    })
    return items;
}

export const getBreadcrumbItemsAdminAsset = (intl, asset, isHda) => {
    const items = []
    items.push({name: intl.formatMessage({id: "page.admin"}), url: '/administration/users'})
    isHda ?
        items.push({name: intl.formatMessage({id: "admin.tab.only.assets"}), url: '/administration/assets'})
        :
        items.push({name: intl.formatMessage({id: "admin.tab.fleets.and.assets"}), url: '/administration/fleets'})
    items.push({
        name: (asset && asset.name && asset.name.length > 0) ? asset.name : intl.formatMessage({id: "admin.tab.assets.new"}),
        url: '/administration/assets/' + ((asset && asset.id > 0) ? asset.id : 'new'),
    })
    return items;
}

export const getBreadcrumbItemsAssetHda = (hdaBreadcrumb, external) => {
    const items = []
    items.push({name: hdaBreadcrumb, url: external ? '/airtime/assets' : '/assets'})
    return items;
}

export const getFieldErrorMessage = (field, errors) => {
    const err = errors.find(item => item.path === field)
    return err ? err.message : null
}

/**
 * Removes Fleets fleet (id=0) from hierarchy root if it is there
 */
export const removeHierarchyRootIfNecessary = (hierarchy) => {
    if (hierarchy && hierarchy.length === 1 && hierarchy[0].id === 0) {
        hierarchy = hierarchy[0].subFleets.length > 0 ? hierarchy[0].subFleets : hierarchy[0].assets
    }
    return hierarchy
}

export const sliceItemsFromEnd = (items, itemsToSlice) => {
    let slicedItems = items
    let remainingItems = []
    if (items.length > itemsToSlice) {
        slicedItems = items.slice(items.length - itemsToSlice, items.length)
        remainingItems = items.slice(0, items.length - itemsToSlice)
    }
    return [slicedItems, remainingItems]
}

export const sliceItemsFromBeginning = (items, itemsToSlice) => {
    let slicedItems = items
    let remainingItems = []
    if (items.length > itemsToSlice) {
        slicedItems = items.slice(0, itemsToSlice)
        remainingItems = items.slice(itemsToSlice, items.length)
    }
    return [slicedItems, remainingItems]
}

export const verifyAirtimeException = (code, logOutCallback) => {
    if (code === AirtimeExceptions.UNIQUE_SESSION_EXPIRED ||
        code === AirtimeExceptions.UNIQUE_SESSION_INVALID ||
        code === AirtimeExceptions.UNIQUE_SESSION_USER_UNAUTHORIZED) {
        logOutCallback();
    }
}
